var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk } from '@reduxjs/toolkit';
import { editorSlice } from 'app/stores/editor';
export const hideBusy = createAsyncThunk('project/busy/hide', (params, { dispatch, getState }) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    let id = null;
    if (!id) {
        const state = getState();
        id = (_a = state.editor.busy) === null || _a === void 0 ? void 0 : _a.id;
    }
    setTimeout(() => {
        dispatch(editorSlice.actions.hideBusyId({ id }));
    }, 500);
    if (!id) {
        throw new Error('Missing id');
    }
    return id;
}));
